// 日语
const jp = {
    // 首页-激活说明
    activateExplain: {
        title: '延長保証を有効にして、特別なプレゼントを手に入れましょう',
        desp: '適用条件：資格を得るために、顧客は、少なくとも1週間アクティブに使用している購入済みの当社製品とショッピング体験を共有することに同意します。',
        conditions: [
            'Amazonで商品を購入したお客様のみ',
            '各顧客は1つの製品に対して1つの無料ギフトのみを請求できます。 （これは、同じ製品を何回購入しても、1つの無料ギフトしか獲得できないことを意味します）',
        ]
    },
    // 首页-激活表单
    activateForm: {
        title: '延長保証を有効にして、今すぐ無料ギフトを入手してください！',
        desp: '既存のお客様のみ利用可能',
        name: '名前',
        namePlaceholder: `受信者の名前を入力`,
        nameErrMsg: `名前が間違っています。`,
        email: 'メール',
        emailPlaceholder: `メールアドレスを入力`,
        emailErrMsg: `メールアドレスが間違っている。`,
        verifCode: '検証コード',
        verifCodePlaceholder: `確認コードを入力してください`,
        verifCodeErrMsg: `不正な検証コード。`,
        btnSendCode: `確認コードを送信する`,
        countdownMsg: `{countdown}秒で再送`,
        orderId: '注文ID',
        orderIdPlaceholder: `注文IDを入力してください`,
        orderIdErrMsg: `注文IDが正しくありません。`,
        orderAppliedError: `この注文はすでにギフトを申請しています。`,
        skuAppliedError: `この注文の贈り物がもう受け取られました。`,
        orderIdHelp: '注文IDの確認方法は？',
        btnAactivate: '今すぐアクティベート',
        statement: 'お客様の個人情報を他者と共有することは絶対にありません。',
        orderIdErrPopoverMsg: 'ご注文IDが正しい場合は、メールでカスタマーサービスまでご連絡ください。 延長保証を有効にし、イベントがあなたの市場をカバーしているかどうかを確認するお手伝いをします。',
        priceErrPopoverMsg: '申し訳ございませんが、ご注文は最大の割引が適用されています、何かご不明点がございましたら、メールでお気軽にご連絡ください。'
    },
    // 通用弹框
    commonModal: {
        msg: `{msg}`,
        msgContents: [
            `受取人の名前は注文と一致できません`,
            `Amazonのレビューが完了したかどうか。`,
            `Amazonにレビューを続けますか？`
        ],
        btnRewrite: 'リライト',
        btnNo: '番号',
        btnYes: 'はい'
    },
    // 选择礼物
    chooseGift: {
        title: '今、あなたが望む贈り物を選択してください。',
        modalTitle: '選択したギフトはご利用いただけません。もう一度選択してください',
        btnWant: '私はそれがほしい',
        btnStockout: '在庫切れ'
    },
    // 订单信息
    orderInfo: {
        title: 'おめでとうございます！ 延長保証が有効になりました！',
        desp: 'あなたが得るもの',
        orderTitle: 'ご注文情報',
        orderId: '注文ID',
        productASIN: '製品ASIN',
        productName: '商品名',
        address: '住所',
        aboutGift: [
            'ギフトについて',
            '送料、隠された料金、クレジットカードは必要ありません',
            'それを取得するための4つの簡単なステップ（5分未満）。',
            'ギフトは、請求後2〜5営業日で発送されます。'
        ],
        btnWant: '私はそれがほしい'
    },
    // 步骤1
    stepOne: {
        title: 'ステップ1/4：購入に関する簡単な調査。',
        questionList: [{
                id: 1,
                select_type: 'radio',
                name: 'sex',
                title: '1. 私は…？',
                option: [{
                        txt: '女性',
                        value: 0
                    },
                    {
                        txt: '男性',
                        value: 1
                    },
                    {
                        txt: 'わからない',
                        value: 2
                    }
                ]
            },
            {
                id: 2,
                select_type: 'radio',
                name: 'age',
                title: `2. あなたの年齢は何歳ですか？`,
                option: [{
                        txt: '20未満',
                        value: 0
                    },
                    {
                        txt: '20-30',
                        value: 1
                    },
                    {
                        txt: '30-40',
                        value: 2
                    },
                    {
                        txt: '40-50',
                        value: 3
                    },
                    {
                        txt: '50-60',
                        value: 4
                    },
                    {
                        txt: '60以上',
                        value: 5
                    }
                ]
            },
            {
                id: 3,
                select_type: 'radio',
                name: 'reason',
                title: '3. なぜ私たちを選んだのですか？',
                option: [{
                        txt: 'ブランド',
                        value: 0
                    },
                    {
                        txt: '設計',
                        value: 1
                    },
                    {
                        txt: '価格',
                        value: 2
                    },
                    {
                        txt: '特徴',
                        value: 3
                    },
                    {
                        txt: 'レビュー',
                        value: 4
                    },
                    {
                        txt: '他の理由',
                        value: 5,
                        placeholder: '理由を入力してください'
                    }
                ]
            },
        ],
        btnNext: '次の一歩'
    },
    // 步骤2
    stepTwo: {
        title: 'ステップ2/4：製品についての経験を教えてください。',
        despOne: `総合評価？`,
        despTwo: `当社の製品がどのように機能しているかをお知らせください。`,
        notice: `（10文字以上入力してください）`,
        commentPlaceholder: 'コメントを入力してください',
        commentErrMsg: `コメントワードは20,000を超えることはできません`,
        btnNext: '次の一歩',
        btnPrev: '前のステップ'
    },
    // 步骤3
    stepThree: {
        title: '手順3/4：ショッピング体験を他のユーザーと共有する。',
        desp: 'ちょうど数秒かかります。 あなたのコメントは、他の顧客がより良い買い物の決定をするのに役立ちます。 ご理解とご支援をお願いいたします。',
        commentTitle: 'あなたのコメント',
        defaultComment: '私はあなたの製品がとても好きです！',
        btnCopyPost: 'アマゾムのレビューをコピーして投稿するには、ここをクリックしてください'
    },
    // 步骤4
    stepFour: {
        title: 'ステップ4/4：住所を確認する。',
        desp: 'あなたが得るもの',
        fullName: '氏名',
        fullNamePlaceholder: `氏名を入力してください`,
        fullNameErrMsg: `氏名が間違っている`,
        phone: '電話',
        phonePlaceholder: `電話番号を入力してください`,
        phoneErrMsg: `電話が間違っている`,
        email: 'メール',
        emailPlaceholder: `メールアドレスを入力`,
        emailErrMsg: `メールアドレスが間違っている`,
        address: '住所',
        addressPlaceholder: `住所を入力`,
        addressErrMsg: `住所が間違っている`,
        streetPlaceholder:`住所`,
        apartmentPlaceholder:`アパート/ユニット`,
        cityPlaceholder:`市`,
        regionPlaceholder: `郡を選択`,
        countryPlaceholder: `国を選択します`,
        postcode: '郵便番号',
        postcodePlaceholder: `郵便番号を入力`,
        postcodeErrMsg: `郵便番号が間違っています`,
        btnComfirm: '確認する'
    },
    // 完成礼物申请
    completeApplication: {
        title: `無料ギフト申請が完了しました`,
        msgs: [
            '無料ギフトは2-5営業日で発送されます。',
            '無料ギフトは、2〜5営業日以内にメール ',
            ' に送信されます。当社の製品をご購入いただき、誠にありがとうございます。アフターセールスチームが専任でご連絡いたします。',
            'さらに問題が発生した場合は、メールでカスタマーサービスにお問い合わせいただくか、公式ウェブサイトにアクセスしてください。',
            'あなたは私たちの製品に100％満足していないので、あなたは私たちのカスタマーサービスに電子メールで連絡するか、私たちの公式ウェブサイトを訪問することができます。 100％の顧客満足は私たちの保証です！'
        ],
        btnComfirm: '確認する'
    },
    // 获取订单号指导
    guide: {
        title: '注文IDの確認方法は',
        desps: [
            `ステップ1：Amazonアカウントにログインし、アカウントとリストのページで[ご注文]をクリックします`,
            `ステップ2：正しい注文で[注文の詳細]をクリックします`,
            `ステップ3：注文IDが表示されます`
        ],
        btnOK: 'OK'
    }
}

export default jp